import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';

import { ICRMStatusList } from '~/utils/interface/crm-status';
import { handleGetCRMStatuses } from './crmStatusThunk';

export interface CRMStatusState {
  selecCRMStatuses: Array<ICRMStatusList>;
  filter: IFilter;
  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;
  crmStatuses: Array<ICRMStatusList>;
  selectedIds: Array<string>;
  crmStatusId: string;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
}

interface IFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const initialState: CRMStatusState = {
  selecCRMStatuses: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
  },
  selectedIds: [],
  crmStatuses: [],
  crmStatusId: '',
  openAlertDelete: false,
  menuSelectedId: undefined,
};

const crmStatusSlice = createSlice({
  name: 'crmStatus',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeCRMStatusId(state, action: PayloadAction<string>) {
      state.crmStatusId = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
      if (!state.openAlertDelete) {
        state.menuSelectedId = undefined;
      }
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetCRMStatuses.pending, (_state, _action) => {})

      .addCase(handleGetCRMStatuses.fulfilled, (state, action) => {
        state.crmStatuses = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.totalPages = action.payload.pagination.totalPages;
        state.needRefreshData = false;
      })

      .addCase(handleGetCRMStatuses.rejected, (_state, _action) => {});
  },
});

export const crmStatusActions = crmStatusSlice.actions;

const crmStatusReducer = crmStatusSlice.reducer;
export default crmStatusReducer;
